import { Box, Flex, HStack, Stack, Text } from "@chakra-ui/react";
import { AttributeDefinition, AttributeType } from "@keita/lanepatrol-sdk";
import { t } from "i18next";
import { ColorByLegendItem } from "./ColorByLegendItem";
import { AttributeUtils } from "../../../../coding/utils/attribute-utils";
import {
  mapGradient,
  mapGradientEnd,
  mapGradientStart,
  mapGradientStep,
} from "../../../../map/utils/map-utils";

interface Props {
  attribute: AttributeDefinition;
}
export const ColorByAttribute: React.FC<Props> = ({ attribute }) => {
  if (attribute.type === AttributeType.Select) {
    const nOptions = attribute.options.length;

    return (
      <>
        {attribute.options.map((option, i) => {
          return (
            <ColorByLegendItem key={i} color={mapGradientStep(nOptions, i)}>
              {AttributeUtils.getOptionLabel(option.value)}
            </ColorByLegendItem>
          );
        })}
      </>
    );
  } else if (attribute.type === AttributeType.TextArea) {
    return (
      <>
        <ColorByLegendItem color={mapGradientStart}>
          {t(`map:colorBy.textArea.filled`)}
        </ColorByLegendItem>
        <ColorByLegendItem color={mapGradientEnd}>
          {t(`map:colorBy.textArea.empty`)}
        </ColorByLegendItem>
      </>
    );
  } else if (attribute.type === AttributeType.Number) {
    const nSteps = 9;
    return (
      <HStack alignItems="stretch" fontSize="xs" my={1}>
        <Flex
          flexShrink={0}
          w="6px"
          flexDir="column"
          borderRadius="3px"
          overflow="hidden"
        >
          {[...Array(nSteps).keys()].map((i) => (
            <Box
              key={i}
              flex={1}
              bgColor={`#${mapGradient.hsvAt(i / nSteps).toHex()}`}
            />
          ))}
        </Flex>
        <Stack gap={4}>
          <Text>{`0 km/h`}</Text>
          <Text>{`> = 90 km/h`}</Text>
        </Stack>
      </HStack>
    );
  }

  return null;
};
